import React from 'react';
import FormularioVentaForm, { FormularioVentaFormDocument } from '../../../components/FormularioVentaForm';
import { PedidoVenta } from '../../../services/pedidoVentaService';

export type PedidoVentaUI = PedidoVenta & {
  ordenCompra?: string;
  transporte?: string;
  ubicacion?: string;
  formaDePago?: string;
  nroSuc?: number;
  cuit?: string;
  tipoIVA?: string;
  dni?: string;
  idCompania?: string;
};

export interface PedidoFormProps {
  pedidoVenta: PedidoVentaUI;
  onPedidoChange: (pedido: PedidoVenta) => void;
  onClienteSearch: () => void;
  onProductoSearch: () => void;
  onSave: () => void;
  loading: boolean;
  saveButtonText?: string;
  readOnly?: boolean;
  tabLabelInfo?: string;
  tabLabelResumen?: string;
  ariaLabelTabs?: string;
}

const PedidoForm: React.FC<PedidoFormProps> = ({
  pedidoVenta,
  onPedidoChange,
  onClienteSearch,
  onProductoSearch,
  onSave,
  loading,
  saveButtonText = 'Guardar Pedido',
  readOnly = false,
  tabLabelInfo = 'Información del Pedido',
  tabLabelResumen = 'Resumen del Pedido',
  ariaLabelTabs = 'pestañas de pedido',
}) => {
  const document = pedidoVenta as FormularioVentaFormDocument;

  const handleChange = (doc: FormularioVentaFormDocument) => {
    onPedidoChange(doc as PedidoVenta);
  };

  return (
    <FormularioVentaForm
      document={document}
      onChange={handleChange}
      onClienteSearch={onClienteSearch}
      onProductoSearch={onProductoSearch}
      onSave={onSave}
      loading={loading}
      saveButtonText={saveButtonText}
      readOnly={readOnly}
      tabLabelInfo={tabLabelInfo}
      tabLabelResumen={tabLabelResumen}
      ariaLabelTabs={ariaLabelTabs}
    />
  );
};

export default PedidoForm;
